import React, { useState, useEffect } from 'react';
// Import Icons
import IconTrolli from '../../assets/icons/cart.svg';
import mapIco from '../../assets/icons/icon-marker-map.svg';
import AwesomeCity from '../../assets/icons/Icon-awesome-city.svg';
import LocationCity from '../../assets/icons/Icon-material-location.svg';

import Logo from '../../assets/logo/LOGO.svg';
import IconProfileLogin from '../../assets/images/profile-icon.png';

import Troli from './Troli';
import { Link } from 'react-router-dom';
import Container from '../../components/misc/Container';
import Login from './Login';
import NotifAll from './Notif/NotifAll';
import NotifInfo from './Notif/NotifInfo';
import NotifPromo from './Notif/NotifPromo';
import SearchResult from './Searchbar/SearchResult';

// Import React Component
import { ReactComponent as SearchIcon } from '../../assets/icons/icon-search-orange.svg';
import { ReactComponent as IconNotif } from '../../assets/icons/icon-notif.svg';
import { ReactComponent as PersonIcon } from '../../assets/icons/icon-person-outline.svg';
import { ReactComponent as OrderIcon } from '../../assets/icons/icon-order.svg';
import { ReactComponent as ExitIcon } from '../../assets/icons/icon-exit.svg';
import { ReactComponent as ChevronDown } from '../../assets/icons/chevron-down-outline.svg';

const HeaderHome = () => {
  const [showTrolly, setShowTrolly] = useState(false);
  const [showPopupLogin, setShowPopupLogin] = useState(false);
  const [showDropdownAcc, setShowDropdownAcc] = useState(false);
  const [showDropdownAddress, setShowDropdownAddress] = useState(false);
  const [showDropdowNotif, setShowDropdowNotif] = useState(false);
  const [showNotifTab, setShowNotifTab] = useState(1);
  const [showSearchResult, setShowSearchResult] = useState(false);
  let showNotification = null;

  function handleShowPopupLogin() {
    setShowPopupLogin(!showPopupLogin);
    setShowTrolly(false);
    setShowDropdownAcc(false);
    setShowDropdownAddress(false);
    setShowDropdowNotif(false);
  }

  function handdleShowTrolli() {
    setShowTrolly(!showTrolly);
    setShowPopupLogin(false);
    setShowDropdownAcc(false);
    setShowDropdownAddress(false);
    setShowDropdowNotif(false);
  }
  function handdleDropdownAcc() {
    setShowDropdownAcc(!showDropdownAcc);
    setShowPopupLogin(false);
    setShowTrolly(false);
    setShowDropdownAddress(false);
    setShowDropdowNotif(false);
  }
  function handdleDropdownAddress() {
    setShowDropdownAddress(!showDropdownAcc);
    setShowPopupLogin(false);
    setShowTrolly(false);
    setShowDropdownAcc(false);
    setShowDropdowNotif(false);
  }
  function handdleDropdownNotif() {
    setShowDropdowNotif(!showDropdowNotif);
    setShowPopupLogin(false);
    setShowTrolly(false);
    setShowDropdownAcc(false);
    setShowDropdownAddress(false);
  }

  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    setPath(window.location.pathname);
  }, [window.location.pathname]);
  switch (showNotifTab) {
    case 1:
      showNotification = <NotifAll />;
      break;
    case 2:
      showNotification = <NotifInfo />;
      break;
    case 3:
      showNotification = <NotifPromo />;
      break;
    default:
      return <div> Error </div>;
  }
  return (
    <div className="flex flex-col w-full fixed z-20 top-0">
      <div className="bg-white w-full flex justify-center shadow ">
        <div className="flex justify-between px-8 xl:px-12 py-4 bg-white w-full max-w-screen-xl">
          <Link
            to="/homepage"
            className="text-2xl tracking-0-78 text-basic-orange capitalize"
          >
            <img alt="Company logos" src={Logo}></img>
          </Link>
          <div className="flex">
            <div className="relative inline-block text-left mx-4">
              <div className="flex justify-center items-center">
                <button
                  className=" flex items-center"
                  onClick={() => handdleDropdownAcc()}
                >
                  <img
                    src={IconProfileLogin}
                    alt="Icon profile"
                    className="h-10 w-10"
                  />
                  <p className="text-basic-orange text-sm ml-4">Hai Stevanie</p>
                </button>
              </div>

              {/* Dropdown */}
              {showDropdownAcc && (
                <div className="origin-top-right absolute right-0 mt-5 w-40 rounded-md shadow-lg">
                  <div className="rounded-md bg-white shadow-xs  pt-2 pb-3 shadow-sm">
                    <div
                      className="py-1"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <Link
                        to="/profile"
                        className="flex items-center my-1 hover:bg-orange-100 px-6 py-2"
                      >
                        <PersonIcon className="w-4 h-4 mr-4" />
                        <p className="text-sm">Akun</p>
                      </Link>

                      <Link
                        to="/order"
                        className="flex items-center my-1 hover:bg-orange-100 px-6 py-2"
                      >
                        <OrderIcon className="w-4 h-4 mr-4" />
                        <p className="text-sm">Pesanan</p>
                      </Link>

                      <Link
                        to="/welcome"
                        className="flex items-center my-1 hover:bg-orange-100 px-6 py-2"
                      >
                        <ExitIcon className="w-4 h-4 mr-4" />
                        <p className="text-sm">Keluar</p>
                      </Link>
                    </div>
                  </div>
                </div>
              )}
              {/* Dropdown End */}
            </div>
            <div className="relative inline-block text-left mx-2 ">
              <div className="flex justify-center items-center h-full">
                <button
                  className="flex items-center outline-none border-none"
                  onClick={() => handdleDropdownNotif()}
                >
                  <IconNotif className="h-6 w-6 mx-2" />
                </button>
              </div>
              {/* Dropdown */}
              {showDropdowNotif && (
                <div className="origin-top-right absolute right-0 mt-5 min-w-fit-content w-96 rounded-md shadow-lg">
                  <div className="rounded-md bg-white shadow-xs  pt-2 pb-3 shadow-sm">
                    <div
                      className="pt-1 pb-4"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <div className="flex px-6 py-3 -mx-1 mb-4">
                        <div
                          className={
                            'mx-1 border  text-font-gray px-3 py-2 rounded-md text-sm cursor-pointer ' +
                            (showNotifTab === 1
                              ? ' border-line-orange-200 bg-line-orange-100'
                              : ' border-gray-200 bg-white ')
                          }
                          onClick={() => setShowNotifTab(1)}
                        >
                          <p>Semua</p>
                        </div>
                        <div
                          className={
                            'mx-1 border  text-font-gray px-3 py-2 rounded-md text-sm cursor-pointer  ' +
                            (showNotifTab === 2
                              ? ' border-line-orange-200 bg-line-orange-100'
                              : ' border-gray-200 bg-white ')
                          }
                          onClick={() => setShowNotifTab(2)}
                        >
                          <p>Info</p>
                        </div>
                        <div
                          className={
                            'mx-1 border  text-font-gray px-3 py-2 rounded-md text-sm cursor-pointer  ' +
                            (showNotifTab === 3
                              ? ' border-line-orange-200 bg-line-orange-100'
                              : ' border-gray-200 bg-white ')
                          }
                          onClick={() => setShowNotifTab(3)}
                        >
                          <p>Promo</p>
                        </div>
                      </div>
                      <div className="flex flex-col w-full">
                        {showNotification}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* Dropdown End */}
            </div>
            <button
              onClick={() => {
                handdleShowTrolli();
              }}
              className="flex items-center ml-2 mr-4 px-2"
            >
              <span>
                {' '}
                <img src={IconTrolli} className="h-6 w-6 mr-2" alt="" />
              </span>
              <p className="text-font-gray">Troli</p>
            </button>
          </div>
        </div>
      </div>

      {path === '/welcome' ? null : (
        <div className="bg-basic-orange py-2 flex justify-center items-center ">
          <Container>
            <div className="w-6/12">
              <label className="relative flex w-full flex-wrap items-stretch ">
                <span className="z-10 leading-snug font-normal absolute text-center text-gray-400 bg-transparent rounded text-base items-center justify-center h-4 w-4 my-3 mx-4">
                  <SearchIcon className="h-4 w-4" />
                </span>
                <input
                  type="text"
                  onFocus={() => {
                    setShowSearchResult(!showSearchResult);
                  }}
                  onBlur={() => {
                    setShowSearchResult(!showSearchResult);
                  }}
                  placeholder="Cari produk disini..."
                  className="form-input  rounded-lg px-3 py-2 placeholder-gray-400 text-gray-700 relative bg-white border-none w-full pl-10 focus:placeholder-opacity-0 "
                />
                {/* Dropdown Search */}
                {showSearchResult && <SearchResult />}
                {/* End Dropdown Search */}
              </label>
            </div>
            <div className="ml-auto flex items-center outline-none">
              <div className="flex">
                <img className="h-6 w-4" src={mapIco} alt="" />
                <p className="mx-4 text-white">Area Pengiriman</p>
              </div>

              <div className="relative inline-block">
                <button
                  className="flex py-2 px-5 items-center"
                  onClick={() => handdleDropdownAddress()}
                >
                  <p className="text-white font-semibold">Kota Malang</p>
                  <ChevronDown className="w-6 h-4 ml-6 text-white" />
                </button>
                {/* Dropdown Address */}
                {showDropdownAddress && (
                  <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-56 rounded-md shadow-lg">
                    <div className="rounded-md bg-white shadow-xs  pt-2 pb-3 shadow-sm">
                      <div
                        className="py-1"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                      >
                        <form action="" className="flex-col flex px-6 w-full">
                          <p className="text-sm my-2">Pilih Kota </p>
                          <div
                            className="flex items-center px-2 hover:bg-orange-100 py-2 cursor-pointer"
                            onClick={() =>
                              setShowDropdownAddress(!showDropdownAddress)
                            }
                          >
                            <img src={AwesomeCity} alt="" className="h-4" />
                            <span className="ml-2 text-sm">
                              Kota <strong>Malang</strong>
                            </span>
                          </div>
                          <div
                            className="flex items-center px-2 hover:bg-orange-100 py-2 cursor-pointer"
                            onClick={() =>
                              setShowDropdownAddress(!showDropdownAddress)
                            }
                          >
                            <img src={LocationCity} alt="" className="h-5" />
                            <span className="ml-2 text-sm">
                              Kota <strong>Surabaya</strong>
                            </span>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
                {/* End Dropdown Address */}
              </div>
            </div>
          </Container>
        </div>
      )}
      {showTrolly ? <Troli handdleClick={handdleShowTrolli} /> : null}
      {showPopupLogin ? <Login handdleClick={handleShowPopupLogin} /> : null}
    </div>
  );
};

export default HeaderHome;
